import usecase1 from "../../images/use-case1.png";
import usecase2 from "../../images/use-case2.png";
import usecase3 from "../../images/use-case3.png";

export const useCases = [
  {
    mainText: "all your creative",
    secondaryText: "tasks simplified",
    thisdText: "with AI.",
    patagraphHero: [
      "Get content ideas, generate captions",
      "that respects brand’s tone of voice,",
      "design and plan your publications all in",
      "one place",
    ],
    places: ["Feedly", "Canva", "Copy.ai", "Hootsuite"],
    image: usecase1,
  },
  {
    mainText: "transparency",
    secondaryText: "over all the work",
    thisdText: "ahead of you",
    patagraphHero: [
      "Plan, track, and manage all your work",
      "with project management that flexes to",
      "your team`s needs",
      "",
    ],
    places: ["Asana", "Monday", "", ""],
    image: usecase2,
  },
  {
    mainText: "your entire",
    secondaryText: "workflow on",
    thisdText: "autopilot",
    patagraphHero: [
      "Eliminate the busywork and focus on",
      "what matters with hundreds of",
      "Automations. Automatically assign",
      "tasks, post comments, update statuses, and sync with other tools.",
    ],
    places: ["UiPath", "Zapier", "Airtable", ""],
    image: usecase3,
  },
  {
    mainText: "transparency",
    secondaryText: "over all the work",
    thisdText: "ahead of you",
    patagraphHero: [
      "Plan, track, and manage all your work",
      "with project management that flexes to",
      "your team`s needs",
      "",
    ],
    places: ["Asana", "Monday", "", ""],
    image: usecase2,
  },
  {
    mainText: "transparency",
    secondaryText: "over all the work",
    thisdText: "ahead of you",
    patagraphHero: [
      "Plan, track, and manage all your work",
      "with project management that flexes to",
      "your team`s needs",
      "",
    ],
    places: ["Asana", "Monday", "", ""],
    image: usecase2,
  },
];
